import { Prop, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import type { DiscoveryInfo } from '@/shared/model/briefing-widget.model';
import { formatDateAgo } from '../../../util/date-util';
import { formattedDate } from '../artical-common';
import moment from 'moment';

@Component({
  methods: { formattedDate, formatDateAgo },
})
export default class NoteDetailComponent extends Vue {
  @Prop() noteData: DiscoveryInfo;

  processDatetimes() {
    const formatDate = formatDateAgo(moment.utc(this.noteData.publishedAt.toString(), 'YYYYMMDDHHmmss'));
    return formatDate;
  }

  newWidowOrigin() {
    window.open(this.noteData.sourceUri, '_blank');
  }
}
